// import React, { useEffect, useState } from 'react'

// const WelcomeGreet = () => {
//   const [greeting, setGreeting] = useState("");

//   const marginTopStyle = {
//     marginTop: "10px"
//   }

//   useEffect(() => {
//     const storedName = sessionStorage.getItem('username');
//     if (storedName) {
//       const currentTime = new Date();
//       const currentHour = currentTime.getHours();
//       let greeting = '';

//       if (currentHour < 12) {
//         greeting = `Good Morning, ${storedName}!`;
//       } else if (currentHour < 17) {
//         greeting = `Good Afternoon, ${storedName}!`;
//       } else {
//         greeting = `Good Evening, ${storedName}!`;
//       }
//       setGreeting(greeting);
//     }
//   }, []);

//   return (
//     <>
//       <div className="row justify-content-between">
//         <div className="col" style={marginTopStyle}>
//           <h1>NewsyDoozy - Top Headlines</h1>
//         </div>
//         <div className="col greeting-container" style={marginTopStyle}>
//           <h1 className='greeting'>{greeting}</h1>
//         </div>
//       </div>
//     </>
//   )
// }

// export default WelcomeGreet





import React, { useEffect, useState } from 'react'

const WelcomeGreet = () => {
  const storedName = sessionStorage.getItem('username');

  const marginTopStyle = {
    marginTop: "10px"
  }

  const generateGreeting = (name) => {
    const currentTime = new Date();
    const currentHour = currentTime.getHours();
    let greeting = '';

    if (currentHour < 12) {
      greeting = `Good Morning, ${name}!`;
    } else if (currentHour < 17) {
      greeting = `Good Afternoon, ${name}!`;
    } else {
      greeting = `Good Evening, ${name}!`;
    }

    return greeting;
  };

  const [greeting, setGreeting] = useState(storedName ? generateGreeting(storedName) : "");

  useEffect(() => {
    if (!greeting && storedName) {
      setGreeting(generateGreeting(storedName));
    }
  }, [greeting, storedName]);

  return (
    <>
      <div className="row justify-content-between">
        <div className="col" style={marginTopStyle}>
          <h1>NewsyDoozy - Top Headlines</h1>
        </div>
        <div className="col greeting-container" style={marginTopStyle}>
          <h1 className='greeting'>{greeting}</h1>
        </div>
      </div>
    </>
  )
}

export default WelcomeGreet